export default function PHP_init() {
  return (
    <div>
      <h1>PHP_init</h1>
    </div>
  );
}
